import Fragment from 'ember-data-model-fragments/fragment';
import type { Type } from '@warp-drive/core/types/symbols';
import { attr } from '@warp-drive/legacy/model';

// Proto: reports.ReportTemplatePeriod.
export default class ReportTemplatePeriod extends Fragment {
  declare [Type]: 'reports/report-template-period';

  @attr('string', { defaultValue: '' })
  declare label: string;

  @attr('number', { defaultValue: 0 })
  declare month: number;

  @attr('number', { defaultValue: 0 })
  declare day: number;
}
